export const dashboards = { 
    agent: "da",
    teamLeader: "dtl",
    admin: "dad",
    codifi: "dc"
}